import { FormFieldTypes } from "../../../components/finalForms/forms/libs/data/formFieldType";

export const addAutoSyncRequest = {
    initialState: {
        tutomerImport: true,
        chemPropertiesImport: true,
        pubChemSync: true,
        productUpdate: false,
        regualtion: true,
        patternTagImport: true,
        saltImport: true,
        isomerImport: true,
    },
    section: [
        {
            sectionId: "AddAutoSync",
            title: "Add Auto Sync",
            row: {},
            style: {
                sectionStyle: "row mb-3",
            },
            fields: [
                {
                    id: "tutomerImport",
                    label: "Tutomer Import ",
                    Field_Name: "tutomerImport",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "tutomerImport",
                    fieldSetting: {
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-xxl-6 col-xl-5 col-md-6 col-6 col-6 ",
                    },
                },
                {
                    id: "chemPropertiesImport",
                    label: "ChemProperties Import ",
                    Field_Name: "chemProperties Import",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "chemPropertiesImport",
                    fieldSetting: {
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-xxl-6 col-xl-5 col-md-6 col-6 col-6 ",
                    },
                },
                {
                    id: "pubChemSync",
                    label: "PubChem Sync ",
                    Field_Name: "pubChemSync",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "pubChemSync",
                    fieldSetting: {
                        allowSpace: true,

                    },
                    style: {
                        containerCss: "col-xxl-6 col-xl-5 col-md-6 col-6 col-6 ",
                    },
                },
                {
                    id: "regualtion",
                    label: "Regualtion ",
                    Field_Name: "regualtion",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "regualtion",
                    fieldSetting: {
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-xxl-6 col-xl-5 col-md-6 col-6 col-6 ",
                    },
                },
                {
                    id: "PatternTag Import ",
                    label: "PatternTag Import",
                    Field_Name: "patternTagImport ",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "patternTagImport",
                    fieldSetting: {
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-xxl-6 col-xl-5 col-md-6 col-6 col-6 ",
                    },
                },
                {
                    id: "Salt Import",
                    label: "Salt Import",
                    Field_Name: "saltImport",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "saltImport",
                    fieldSetting: {
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-xxl-6 col-xl-5 col-md-6 col-6 col-6 ",
                    },
                },
                {
                    id: "Isomer Import",
                    label: "Isomer Import",
                    Field_Name: "isomerImport",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "isomerImport",
                    fieldSetting: {
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-xxl-6 col-xl-5 col-md-6 col-6 col-6 ",
                    },
                },
                {
                    id: "productUpdate",
                    label: "Product Update ",
                    Field_Name: "productUpdate",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "productUpdate",
                    fieldSetting: {
                        allowSpace: true,
                        disabled: true,
                    },
                    style: {
                        containerCss: "col-xxl-6 col-xl-5 col-md-6 col-6 col-6 text-muted",
                    },
                },
            ],
        },
    ],
    formSetting: {
        isViewOnly: false,
    },
};
